import { tvpil } from '../compat/tvpil';
import { queryClient } from '../queryClient';
import { queryKeys } from '../queryKeys';

import { fetchLastWatched } from './fetchLastWatched';
import { createLastWatched } from './utils';

type GetLastWatchedArgs = {
  referenceId: string;
  pageReferenceId?: string;
};

export function getLastWatched({ referenceId, pageReferenceId }: GetLastWatchedArgs) {
  const category = tvpil.categoryTreeItemsMap.get(referenceId);

  if (!pageReferenceId || !category) {
    return;
  }

  const lastWatchedData = queryClient.getQueryData<Awaited<ReturnType<typeof fetchLastWatched>>>(queryKeys.lastWatched);

  return createLastWatched({
    defaultChannelId: category.railProperty.defaultChannel,
    lastWatchedData,
    pageReferenceId,
  });
}
